<template>
  <Modal ref="modal" title="Aviso de Créditos" @cancel="close">
    <div class="modal-container">
      <div class="warning-box">
        <div class="icon-wrapper">
          <span class="warning-icon">⚠️</span>
        </div>
        <div class="content">
          <h3 class="warning-title">Atenção!</h3>
          <p class="warning-message">
            Ao confirmar este agendamento, <strong>1 crédito será consumido imediatamente do saldo.</strong>
          </p>
        </div>
      </div>
      
      <p class="confirmation-text">
        Deseja continuar com o agendamento?
      </p>

      <div class="buttons">
        <Button @handle:click="close" text="Cancelar" color="danger" />
        <Button @handle:click="handleConfirm" text="Confirmar e Agendar" color="primary" />
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from 'core/Modal'
import Button from 'core/Button'

export default {
  name: 'CreditWarningModal',
  components: {
    Modal,
    Button,
  },
  props: {
    onConfirm: Function,
  },
  data() {
    return {
      data: null,
    }
  },
  methods: {
    open(data) {
      this.data = data
      this.$refs.modal.open()
    },
    close() {
      this.data = null
      this.$refs.modal.close()
    },
    handleConfirm() {
      if (this.onConfirm && this.data) {
        this.onConfirm(this.data)
      }
      this.close()
    },
  }
}
</script>

<style lang="scss" scoped>
.modal-container {
  width: 35rem;
  display: flex;
  flex-direction: column;
  gap: 1.75rem;
  padding: 1rem 0;

  .warning-box {
    display: flex;
    gap: 1rem;
    padding: 1.25rem;
    background: linear-gradient(135deg, #FFF5E6 0%, #FFE8CC 100%);
    border: 2px solid #FFB020;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(255, 176, 32, 0.15);

    .icon-wrapper {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 3rem;
      height: 3rem;
      background: #FFFFFF;
      border-radius: 50%;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);

      .warning-icon {
        font-size: 1.75rem;
        line-height: 1;
      }
    }

    .content {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      .warning-title {
        margin: 0;
        font-size: 1.125rem;
        font-weight: 700;
        color: #D84315;
        line-height: 1.3;
      }

      .warning-message {
        margin: 0;
        font-size: 0.9375rem;
        line-height: 1.5;
        color: #5D4037;

        strong {
          color: #BF360C;
          font-weight: 700;
        }
      }
    }
  }

  .confirmation-text {
    margin: 0;
    font-size: 1.0625rem;
    font-weight: 600;
    color: #202224;
    text-align: center;
  }

  .buttons {
    align-self: flex-end;
    display: flex;
    align-items: center;
    gap: 1rem;
    margin-top: 0.5rem;
  }
}
</style>
